import { bcs } from '@mysten/sui.js/bcs';

export const metadataBcsType = {
  groupId: 'string',
  name: 'string',
};

export interface StreamMetadata {
  groupId: string;
  name: string;
}

export function decodeMetadata(metaStr: string) {
  return bcs.de(metadataBcsType, metaStr, 'base64') as StreamMetadata;
}
